import React from 'react';
import ActionTable from './ActionTable';
 
export default function Action() {
  return (
<div>

<ActionTable />
</div>
  );
}